import { useMemo } from 'react';
import { getInstalledWallets, getNotInstalledWallets } from '../../../views/WalletList/data.js';
import { getMagicLinkApiKeyFromProviders } from './utils/getMagicLinkApiKeyFromProviders/getMagicLinkApiKeyFromProviders.js';

const useWallets = ({ projectSettings, appLogoUrl, appName, networkConfigurations, vendorCredentials, walletUiUtils, magicLinkConfig, }) => {
    const wallets = useMemo(() => {
        if (!projectSettings)
            return [];
        const magicLinkApiKey = getMagicLinkApiKeyFromProviders((projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.providers) || []);
        const installedWallets = getInstalledWallets(projectSettings, {
            appLogoUrl,
            appName,
            magicLinkApiKey,
            magicLinkConfig,
            networkConfigurations,
            skipMemo: true,
            vendorCredentials,
            walletUiUtils,
        });
        const notInstalledWallets = getNotInstalledWallets(projectSettings, {
            appLogoUrl,
            appName,
            magicLinkApiKey,
            magicLinkConfig,
            networkConfigurations,
            skipMemo: true,
            vendorCredentials,
            walletUiUtils,
        });
        const unfilteredWallets = [...installedWallets, ...notInstalledWallets];
        return unfilteredWallets;
    }, [
        projectSettings,
        appLogoUrl,
        appName,
        vendorCredentials,
        networkConfigurations,
    ]);
    return { wallets };
};

export { useWallets };
